import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config' 
const getPermById = (id) => {
    let reqid=id
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const getOrg = async (id) => {
          try {
            const res = await axios.get(`${app.URL}/perm/viewperm/${id}`);
            console.log(res);
            setResponse(res.data);
            setLoading(false);
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        getOrg(reqid);
      }, []);
    
      return { loading, response, error };
    };
export default getPermById